module.exports = __webpack_public_path__ + "img/Atenção.8a6fbc05.gif";